export type FieldErrors = Record<string, string>

export function collectErrors(form: HTMLFormElement, messages: FieldErrors): FieldErrors {
  const errors: FieldErrors = {}

  for (const element of form.elements) {
    if (element instanceof HTMLInputElement && element.willValidate && !element.checkValidity()) {
      errors[element.name] = messages[element.name] ?? element.validationMessage
    }
  }

  return errors
}
